import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";

// MUI Components
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles({
  root: {
    flex: "1 1 auto",
    flexDirection: "column",
    marginTop: "20px",
  },
  imagePlaceholder: {
    height: "320px",
    width: "calc(100% - 80px)",
    backgroundColor: "rgba(255, 255, 255, 0.09)",
    border: "2px rgba(255, 255, 255, 0.2) dashed",
  },
  imgContainer: {
    width: "calc(100% - 50px)",
  },
});

const PhotoDisplay = (props) => {
  const classes = useStyles();

  return (
    <Grid item container wrap="nowrap" className={classes.root}>
      {props.sample.picture === null ? (
        // Image Placeholder
        <Grid item container direction="column" alignItems="center">
          <div className={classes.imagePlaceholder} />
        </Grid>
      ) : (
        // Picture display in results column
        <Grid item container direction="column" alignItems="center">
          <img
            // height={320}
            className={classes.imgContainer}
            src={props.sample.picture}
            alt={"Captured from Webcam."}
          />
        </Grid>
      )}
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    sample: state.samples.byId[state.samples.selectedSampleId],
  };
};

export default connect(mapStateToProps)(PhotoDisplay);
